'use client';

import {
  CssProps,
  Divider,
  HStack,
  Item,
  VStack,
} from '@nettbureau/vibrant-ui';
import { Children, ReactNode, useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';

export type CardActionsProps = {
  children?: ReactNode;
} & CssProps;

export function CardActions({ children, className }: CardActionsProps) {
  const childrenList = Children.toArray(children);

  const { cardStyle } = useContext(ConfigContext);

  return (
    <VStack justify="end" align="stretch">
      {cardStyle === 'Fixed' && (
        <Item grow>
          <Divider />
        </Item>
      )}

      <HStack
        padding={{ y: cardStyle === 'Fixed' ? 2 : 4 }}
        gap="xl"
        justify="center"
        className={className}
      >
        {childrenList.map((child) => {
          return child;
        })}
      </HStack>
    </VStack>
  );
}
